import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { SettingKey } from 'src/constants';
import { ISetting } from 'src/models/setting.model';
import services from 'src/services/setting.service';

export const actionTypes = {
  SETTING_FETCH: 'SETTING_FETCH',
  SETTING_ADD: 'SETTING_ADD',
  SETTING_UPDATE: 'SETTING_UPDATE',
  SETTING_DELETE: 'SETTING_DELETE',
  CONFIGURATION_FIND_BY_KEY_FETCH: 'CONFIGURATION_FIND_BY_KEY_FETCH',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.SETTING_FETCH,
    service: services.listGET,
    meta: { error: false },
  },
  addPOST: {
    type: actionTypes.SETTING_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.SETTING_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.SETTING_DELETE,
    service: services.itemDELETE,
    meta: { error: false },
  },
  findByKeyGET: {
    type: actionTypes.CONFIGURATION_FIND_BY_KEY_FETCH,
    service: services.findByKeyGET,
  },
};

export type ISettingAsync = typeof asyncActions;

export interface ISettingState extends ICommonState<ISettingAsync> {
  data?: ISetting;
  list: ISetting[];
  total: number;
  listByKey: Partial<Record<SettingKey, ISetting>>;
}

export const defaultState: ISettingState = {
  status: {},
  list: [],
  total: 0,
  listByKey: {},
};

const SettingReducer = (
  state: ISettingState = defaultState,
  action: IReducerAction<ISettingAsync>
): ISettingState => {
  switch (action.type) {
    case actionTypes.SETTING_FETCH: {
      const list = action.payload?.rows ?? [];

      return {
        ...state,
        list,
        total: action.payload?.count ?? 0,
        listByKey: list.reduce(
          (items, item) => ({
            ...items,
            [item.key]: !Number.isNaN(Number(item.value))
              ? Number(item.value)
              : item.value,
          }),
          {}
        ),
      };
    }

    case actionTypes.CONFIGURATION_FIND_BY_KEY_FETCH: {
      if (action.params) {
        const [key] = action.params;

        if (key) {
          return {
            ...state,
            listByKey: {
              ...state.listByKey,
              [key]: action.payload?.configSetting,
            },
          };
        }
      }

      return state;
    }

    default: {
      return state;
    }
  }
};

export default SettingReducer;
